module.exports = __webpack_public_path__ + "static/img/IMG_20150307_171210.578411be.jpg";